import { ChangeDetectorRef, Directive, Input, ViewRef, inject } from '@angular/core';
import { ListingSort } from '@df/catalog-ui/listing/sort/listing-sort';
import { App } from '@df/core/app';

@Directive()
export class ListingSortComponentDef<TSort extends ListingSort = ListingSort> {
    /**
     * Access to app
     */
    readonly app = inject(App);

    constructor(private ref: ChangeDetectorRef) {}

    /**
     * Sort model binding
     */
    @Input({
        required: true
    })
    sort!: TSort;

    /**
     * Is open
     */
    protected _open: boolean = false;
    set open(value: boolean) {
        this.openSetter(value);
    }
    get open() {
        return this._open;
    }

    protected openSetter(value: boolean) {
        this._open = value;
        this.detectChanges();
    }

    detectChanges(): void {
        const cd = this.ref;
        if (cd && !(<ViewRef>cd).destroyed) {
            cd.detectChanges();
        }
    }
}
